import * as React from "react";
import { CardsGroup as CardsGroupType } from "../../utils";
import "../Month.css";
import { localedFormat } from "../../../../utils";
import cn from "classnames";
import CardInner from "./CardInner/CardInner";
import HistoryIcon from '@material-ui/icons/History';

interface Props {
	cardsGroup: CardsGroupType;
	isEmpty?: boolean;
}

const CardsGroup: React.FC<Props> = ({ cardsGroup, isEmpty }) => {
	const short =
		cardsGroup.startDate === cardsGroup.endDate ||
		!cardsGroup.endDate ||
		cardsGroup.endNextMonth ||
		cardsGroup.startNextMonth;

	return (
		<div className="mobile-calendar-month-group">
			<div
				className={cn("mobile-calendar-month-group__dates", {
					"mobile-calendar-month-group__dates_oneday": short,
					"mobile-calendar-month-group__dates_hidden": cardsGroup.startNextMonth,
					"mobile-calendar-month-group__dates_want": !cardsGroup.startDate
				})}
			>
				<div
					className={cn("mobile-calendar-month-group__date", {
						"mobile-calendar-month-group__date_hidden":
							cardsGroup.startNextMonth,
					})}
				>
					{cardsGroup.startDate >= 1 && <div className="mobile-calendar-month-group__date__dow">
						{localedFormat(cardsGroup.cards[0].startDate, "cccccc")}
					</div>}

					<div className="mobile-calendar-month-group__date__round">
						{cardsGroup.startDate >= 1 ? cardsGroup.startDate : <HistoryIcon/>}
					</div>
				</div>

				{cardsGroup.cards[0].endDate && !cardsGroup.endNextMonth && (
					<div
						className={cn(
							"mobile-calendar-month-group__date mobile-calendar-month-group__date_end",
							{
								"mobile-calendar-month-group__date_hidden":
									cardsGroup.endNextMonth,
							}
						)}
					>
						<div className="mobile-calendar-month-group__date__dow">
							{localedFormat(cardsGroup.cards[0].endDate, "cccccc")}
						</div>

						<div className="mobile-calendar-month-group__date__round">
							{cardsGroup.endDate}
						</div>
					</div>
				)}
			</div>

			<div
				className={cn("mobile-calendar-month-group__cards", {
					"mobile-calendar-month-group__cards_short": short,
					"mobile-calendar-month-group__cards_otherMonth": cardsGroup.startNextMonth,
					"mobile-calendar-month-group__cards_empty": isEmpty,
				})}
			>
				{!isEmpty && <>
					{!cardsGroup.startDate && <div className="mobile-calendar-month-group__cards_want">
						Запланировано
					</div> }

					{cardsGroup.cards.map((card) => (
						<CardInner
							card={card}
							key={card.card.eId}
							startInOtherMonth={cardsGroup.startNextMonth}
							hidePeriod={!cardsGroup.startDate}
						/>
					))}
					</>}

				{isEmpty && <div>Нет книг для отображения в этот период</div>}
			</div>
		</div>
	);
};

export default CardsGroup;
